/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Modal } from 'react-bootstrap-v5'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { SupplierModel } from '../../models/SupplierModel'
import { useIntl } from 'react-intl'
import { formatPrice } from '../../selectors'
import useMasterData from '../../hooks/useMaster'
import { DEFAULT_PER_PAGE } from '../../constants/common'

type Props = {
  show: boolean
  mode: string
  data?: SupplierModel
  validDate?: string
  onClose: () => void
  onSubmit: (values: any, actions: any) => void
}

const editSchema = Yup.object().shape({
  email: Yup.string().email().required().label('Email'),
  tax_code: Yup.string().required().label('Mã số thuế'),
  name: Yup.string().required('Tên nhà cung cấp không được bỏ trống.').max(255).label('Tên nhà cung cấp'),
  phone: Yup.string().required('Số điện thoại nhà cung cấp không được bỏ trống.').label('Số điện thoại nhà cung cấp'),
  address: Yup.string().required('Địa chỉ nhà cung cấp không được bỏ trống.').label('Địa chỉ nhà cung cấp')
});

const initSearch = {
  page: 1,
  per_page: DEFAULT_PER_PAGE,
}


const ConsignmentSupplierEditModal: React.FC<Props> = ({ show, mode, data, onClose, onSubmit }) => {
  const intl = useIntl();
  const {master} = useMasterData();

  let initValues: any = {
    name: '',
    email: '',
    phone: '',
    address: ''
  };
  if (data) {
    initValues = {
      ...initValues,
      id: data.id,
      name: data.name,
      email: data.email,
      supplier_code: data.supplier_code,
      address: data.address,
      phone: data.phone,
      tax_code: data.tax_code
    }
  }

  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby='contained-modal-title-vcenter'
      centered
      className='modal-overflow-y'
    >
      <Modal.Header className='d-flex'>
        <Modal.Title>Nhà cung cấp {data?.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-10">
        <Formik validationSchema={editSchema} initialValues={initValues} onSubmit={onSubmit} validateOnMount initialTouched={initValues}>
          {({ values, handleChange }) => (
            <Form>
              <div className="row mb-3">
                <div className="col-md-12 mb-3">
                  <label className="required form-label">Tên NCC</label>
                  <Field
                    type='text'
                    className='form-control'
                    placeholder=''
                    autoComplete='nope'
                    name='name'
                  />
                  <ErrorMessage name='name' className='text-danger' component='span' />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="required form-label">Mã NCC</label>
                  <Field
                    type='text'
                    className='form-control'
                    placeholder=''
                    autoComplete='nope'
                    name='supplier_code'
                  />
                  <ErrorMessage name='supplier_code' className='text-danger' component='span' />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="required form-label">Mã số thuế</label>
                  <Field
                    type='text'
                    className='form-control'
                    placeholder=''
                    autoComplete='nope'
                    name='tax_code'
                  />
                  <ErrorMessage name='tax_code' className='text-danger' component='span' />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="required form-label">Email</label>
                  <Field
                    type='text'
                    className='form-control'
                    placeholder=''
                    autoComplete='nope'
                    name='email'
                  />
                  <ErrorMessage name='email' className='text-danger' component='span' />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="required form-label">Số điện thoại</label>
                  <Field
                    type='text'
                    className='form-control'
                    placeholder=''
                    autoComplete='nope'
                    name='phone'
                  />
                  <ErrorMessage name='phone' className='text-danger' component='span' />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="required form-label">Địa chỉ</label>
                  <Field
                    type='text'
                    className='form-control'
                    placeholder=''
                    autoComplete='nope'
                    name='address'
                  />
                  <ErrorMessage name='address' className='text-danger' component='span' />
                </div>
              </div>
              <div className='d-flex mb-4 justify-content-between pt-8'>
                <button className="btn btn-bg-secondary mx-2" type="button" onClick={() => onClose()}>
                  {intl.formatMessage({ id: 'COMMON.CLOSE' })}
                </button>
                <button className="btn btn-bg-success text-light ml-2" type="submit">
                  {mode === 'edit' ? intl.formatMessage({ id: 'COMMON.UPDATE' }) :
                    intl.formatMessage({ id: 'COMMON.CREATE' })}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default ConsignmentSupplierEditModal
